import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bf20cda"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "template-lock-skeleton",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  key: 1,
  class: "template-lock-panel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["template-lock-wrap", { 'is-compact': _ctx.compact && (_ctx.resolvedState === 'locked' || _ctx.resolvedState === 'pending') }])
  }, [
    (_ctx.resolvedState === 'pending')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skeletonRows, (i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "skeleton-row"
            }))
          }), 128))
        ]))
      : (_ctx.resolvedState === 'locked')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "button",
              class: "template-lock-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('unlock')))
            }, _toDisplayString(_ctx.text), 1)
          ]))
        : _renderSlot(_ctx.$slots, "default", { key: 2 }, undefined, true)
  ], 2))
}